import {
  AutocompleteInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  TextInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import parserFormatNumInput from "../../../utils/parserFormatNumInput";

const filterWidthSx = { width: 240, minWidth: 240 };

const priceFilterList = [
  // <TextInput
  //   variant="outlined"
  //   source="all"
  //   label="mine.filter.search_all"
  //   alwaysOn
  //   resettable
  //   InputProps={{
  //     endAdornment: (
  //       <InputAdornment position="end">
  //         <SearchIcon />
  //       </InputAdornment>
  //     ),
  //   }}
  // />,
  <TextInput
    source="code"
    label="mine.label.code"
    alwaysOn
    resettable
    variant="outlined"
    placeholder="Contoh: G36 atau G36,G40"
    sx={filterWidthSx}
  />,
  <TextInput
    source="brand_code"
    label="Brand"
    alwaysOn
    resettable
    variant="outlined"
    placeholder="Contoh: G,M,S"
    sx={filterWidthSx}
  />,
  <TextInput
    source="size_code"
    label="Ukuran"
    alwaysOn
    resettable
    variant="outlined"
    placeholder="Contoh: 36,40,60"
    sx={filterWidthSx}
  />,
  <TextInput
    source="motif_code"
    label="Motif"
    alwaysOn
    resettable
    variant="outlined"
    placeholder="Contoh: VSA,ZIM,BEV"
    sx={filterWidthSx}
  />,
  <TextInput
    source="code_symbol"
    label="Simbol karakter ke-7"
    alwaysOn
    resettable
    variant="outlined"
    placeholder="Contoh: #,$,:"
    sx={filterWidthSx}
  />,  
  <ReferenceInput
    alwaysOn
    source="quality_id"
    reference="qualities"
    label="mine.label.quality"
    sort={{ field: "qualities.code", order: "ASC" }}
  >
    <AutocompleteInput
      optionText="code"
      variant="outlined"
      label="mine.label.quality"
      sx={filterWidthSx}
    />
  </ReferenceInput>,
  <TextInput
    variant="outlined"
    source="buy_price"
    label="mine.label.buy_price"
    alwaysOn
    resettable
    InputProps={{
      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
    }}
    {...parserFormatNumInput}
    sx={filterWidthSx}
  />,
  <TextInput
    variant="outlined"
    source="sell_price"
    label="mine.label.sell_price"
    alwaysOn
    resettable
    InputProps={{
      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
    }}
    {...parserFormatNumInput}
    sx={filterWidthSx}
  />,
  <MuiDatePickerInput
    variant="outlined"
    source="start_date"
    label="mine.label.start_date"
    alwaysOn
    maxDateSource="end_date"
    textFieldProps={{ sx: filterWidthSx }}
  />,
  <MuiDatePickerInput
    variant="outlined"
    source="end_date"
    label="mine.label.end_date"
    alwaysOn
    minDateSource="start_date"
    textFieldProps={{ sx: filterWidthSx }}
  />,
];

export default priceFilterList;
